export class OTP_STATE {
    public static readonly METHODS = 'methods';
    public static readonly OTP = 'otp';
    public static readonly SESSION_EXPIRE = 'session_expire';
  };


// WEBPACK FOOTER //
// ./src/app/components/verify-otp/otp-state.ts